export default {
  'sendpasswordsuccessfully.sendpassword': 'تم إرسال كلمة المرور بنجاح',
  'sendpasswordsuccessfully.and': 'و',
  'sendpasswordsuccessfully.successfully': 'بنجاح',
  'sendpasswordsuccessfully.passwordsentto':
    'إرسال رابط استعادة كلمة المرور إلى البريد الإلكتروني ',
  'sendpasswordsuccessfully.checkemail':
    'يرجى التحقق من بريدك الإلكتروني لإعادة تعيين كلمة المرور',
};
